export default "__VITE_ASSET__oV6Pax4v__"